import { useEffect } from "react";

// Default meta values, mirroring the static tags in public/index.html.
// Crawlers that don't run JS always see these; this hook updates the same
// tags in place (no duplicates) so JS-aware previews get per-page cards.
const DEFAULTS = {
  title: "MapCast — Live where you are.",
  description: "MapCast — the world's AI-powered, real-time location platform. Connecting humanity through places.",
  ogTitle: "MapCast — Live where you are.",
  ogDescription: "The world's AI-powered, real-time location platform. Connecting humanity through places.",
  ogImage: "https://mapcast.cc/assets/og-cover.jpg",
  ogUrl: "https://mapcast.cc",
};

const setMeta = (attr, key, content) => {
  const el = document.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.setAttribute("content", content);
};

export const usePageMeta = ({ title, description, ogTitle, ogDescription, ogImage, ogUrl }) => {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", ogTitle);
    setMeta("property", "og:description", ogDescription);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:url", ogUrl);
    setMeta("name", "twitter:title", ogTitle);
    setMeta("name", "twitter:description", ogDescription);
    setMeta("name", "twitter:image", ogImage);
    return () => {
      document.title = DEFAULTS.title;
      setMeta("name", "description", DEFAULTS.description);
      setMeta("property", "og:title", DEFAULTS.ogTitle);
      setMeta("property", "og:description", DEFAULTS.ogDescription);
      setMeta("property", "og:image", DEFAULTS.ogImage);
      setMeta("property", "og:url", DEFAULTS.ogUrl);
      setMeta("name", "twitter:title", DEFAULTS.ogTitle);
      setMeta("name", "twitter:description", DEFAULTS.ogDescription);
      setMeta("name", "twitter:image", DEFAULTS.ogImage);
    };
  }, [title, description, ogTitle, ogDescription, ogImage, ogUrl]);
};

export default usePageMeta;
